export default __webpack_public_path__ + "static/media/ProductCategories.6823e9f9.png";